import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import React, { ReactElement, ReactNode } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { emptyString } from '~common/helper/string';

export interface SelectFieldOption {
  value: string | number;
  name: string;
}

export interface SelectFieldProps extends FieldRenderProps<string> {
  renderField: () => ReactNode;
  options: SelectFieldOption[];
  disabled?: boolean;
}

export const Select = (props: SelectFieldProps): ReactElement => {
  const { meta, disabled, renderField } = props;
  const showError = meta.touched && meta.invalid;
  const showHelperText = showError && meta.active && meta.error !== emptyString;

  return (
    <FormControl
      fullWidth
      error={showError}
      classes={{ root: 'form-control-root' }}
      disabled={disabled ?? false}
    >
      {renderField()}
      {showHelperText && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
};



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/common/src/components/select.component.tsx